module.exports = __webpack_public_path__ + "img/right.9b8d17b6.webp";